export const ASSET_ADMINISTRATION_PERMISSIONS = {
  VIEW: 'view_asset_management',
} as const;

export type AssetAdministrationPermissions = typeof ASSET_ADMINISTRATION_PERMISSIONS[keyof typeof ASSET_ADMINISTRATION_PERMISSIONS];
